import { ReportingService, Totals } from 'app/model/services/reporting.service';
import { ReportCostsComponent } from '../report-costs/report-costs.component';
import { Route } from './../../../types/route-data';
import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';

@Component({
  selector: 'app-report-nav',
  templateUrl: './report-nav.component.html',
  styleUrls: ['./report-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportNavComponent implements OnInit {
  public get routeName(): string {
    if (!this._route) return '';
    return this._route.name;
  }

  public get isRouteSet(): boolean {
    return !!this._route;
  }

  private _totals?: { [key: string]: number };

  public get materialCost(): string {
    if (!!this._totals?.materials) {
      return '$' + Math.round(Number(this._totals.materials));
    }
    return '';

  }
  public get laborCost(): string {
    if (!!this._totals?.labor) {
      return '$' + Math.round(Number(this._totals.labor));
    }
    return '';
  }
  public get supplCost(): string {
    if (!this._totals?.supplemental) return '';
    return '$' + Math.round(Number(this._totals.supplemental));

    return '';
  }
  public get totalCost(): string {
    if (!!this._totals?.grand) {
      return '$' + Math.round(Number(this._totals.grand));
    }
    return '';
  }

  public get isExpanded():boolean {
    if(!this._route) return false;
    return this._route.expanded === true;
  }

  private _route?: Route;
  @Input() set route(val: Route | undefined) {
    this._route = val;
    if(!!this.rpts && !!val) this.rpts.SetRoute(val!);
    this.Refresh();
  }
  public get route(): Route | undefined {
    return this._route;
  }
  private _ready: boolean = false;
  constructor(private cdr: ChangeDetectorRef,private rpts:ReportingService) {
    this.cdr.detach();
  }
  ShowCostReport() {
    this.rpts.SetReport('costs');
  }
  ShowSummaryReport() {
    this.rpts.SetReport('summary');
  }
  ShowSupplReport() {
    this.rpts.SetReport('supplemental');

  }
  ngOnInit(): void {
    console.log('here');
    this._ready = true;
    this.rpts.totalsChange.subscribe((value:Totals)=>{
      this._totals = value;
      this.Refresh();
    })
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
}
